import * as React from "react";

import "./scss/index.scss";

class MenuDropdown extends React.Component<
  {
    head: React.ReactElement<any>;
    headLabel?: string;
    content: React.ReactElement<{}>;
    suffixClass: string;
  },
  { active: boolean }
> {
  static defaultProps = {
    suffixClass: "",
  };
  constructor(props) {
    super(props);
    this.state = { active: false };
  }

  handleBlur = (event: React.FocusEvent<HTMLDivElement>) => {
    if (!event.currentTarget.contains(event.relatedTarget as Node)) {
      this.setState({ active: false });
    }
  };

  handleHeadKeyDown = (event: React.KeyboardEvent<HTMLElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      this.setState(({ active }) => ({ active: !active }));
    } else if (event.key === "Escape") {
      this.setState({ active: false });
    }
  };

  render() {
    return (
      <div
        data-testid="user-btn"
        className="menu-dropdown"
        onBlur={this.handleBlur}
        onMouseEnter={() => this.setState({ active: true })}
        onMouseLeave={() => this.setState({ active: false })}
      >
        {React.cloneElement(this.props.head, {
          "aria-expanded": this.state.active,
          "aria-haspopup": "menu",
          "aria-label": this.props.headLabel || "Open account menu",
          onClick: () => this.setState(({ active }) => ({ active: !active })),
          onKeyDown: this.handleHeadKeyDown,
          role: "button",
          tabIndex: 0,
        })}

        <div
          aria-hidden={!this.state.active}
          className={`menu-dropdown__body${" menu-dropdown__body" +
            this.props.suffixClass}${
            this.state.active ? " menu-dropdown__body--visible" : ""
          }`}
        >
          {this.props.content}
        </div>
      </div>
    );
  }
}

export default MenuDropdown;
